export const HOME = '/';
export const NOT_FOUND = '/404';
export const RESOURCES = '#resources';
export const EC = '#early-childhood';
export const CHILDREN = '#children';
export const YOUTH = '#youth';
export const PLANNING = '#planning';
export const FAQ = '#faq';
export const PRICING = '#pricing';